import React from 'react'

function BookingArea() {
  return (
    <div className="booking-area">
        <div className="container">
            <div className="booking-form">
                <h4 className="booking-title">Join TaxiDo</h4>
                {/* <p className="booking-description">Become a part of our community! Apply to be a driver or rider with TaxiDo and enjoy a reliable, rewarding, and flexible platform for your transportation needs.</p> */}
                <form action="submit-booking">
                    <div className="row">
                        <div className="col-lg-3">
                            <div className="form-group">
                                <label>Full Name</label>
                                <input type="text" className="form-control" placeholder="Enter your full name" required />
                                <i className="far fa-user"></i>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="form-group">
                                <label>Email Address</label>
                                <input type="email" className="form-control" placeholder="Enter your email" required />
                                <i className="far fa-envelope"></i>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="form-group">
                                <label>Phone Number</label>
                                <input type="tel" className="form-control" placeholder="Enter your phone number" required />
                                <i className="far fa-phone"></i>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label>Role Applying For</label>
                                <select className="form-control select" required>
                                    <option value="">Choose Role</option>
                                    <option value="driver">Driver</option>
                                    <option value="rider">Rider</option>
                                </select>
                                <i className="far fa-briefcase"></i>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="form-group">
                                <label>City of Operation</label>
                                <input type="text" className="form-control" placeholder="Enter your city" required />
                                <i className="far fa-city"></i>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="form-group">
                                <label>Vehicle Type (For Drivers)</label>
                                <select className="form-control select">
                                    <option value="">Choose Vehicle Type</option>
                                    <option value="car">Car</option>
                                    <option value="motorbike">Motorbike</option>
                                    <option value="van">Van</option>
                                    <option value="other">Other</option>
                                </select>
                                <i className="far fa-car"></i>
                            </div>
                        </div>
                        <div className="col-lg-2 align-self-end">
                            <button className="theme-btn" type="submit">Apply<i
                                    className="pi pi-arrow-right"></i></button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
  )
}

export default BookingArea